import React, { useState, useEffect, useRef } from "react";
import NumberFlow from '@number-flow/react'

import waco from "../../assets/waco.jpg";
import { ArrowRight } from "lucide-react";

const About = () => {
    const [hoveredImage, setHoveredImage] = useState(null);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statValue, setStatValue] = useState(0);
    const statRef = useRef(null);

    // Rotation patterns for variety
    const rotations = [-7, 3, 5, -5, -7, 3, 5, -5, -7, 3, 5, 5, -5, 5, 2, -2];

    // Fetch images from Cloud Function
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await fetch('https://us-central1-wacofirefightersbenefit.cloudfunctions.net/listAboutImages');
                const data = await response.json();
                setImages(data.images || []);
            } catch (error) {
                console.error('Error fetching images:', error);
                setImages([]);
            } finally {
                setLoading(false);
            }
        };

        fetchImages();
    }, []);

    useEffect(() => {
        const el = statRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setStatValue(154000);
            },
            { threshold: 0.2 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const handleMouseEnter = (imageName) => {
        setHoveredImage(imageName);
    };

    const handleMouseLeave = () => {
        setHoveredImage(null);
    };
    return (
        <div className="max-w-[60ch] mx-auto p-[10px] text-[16pt] flex flex-col items-center leading-[1.5] text-center max-md:text-[12pt] max-md:max-w-[50ch] gap-5">

            <div ref={statRef} className="flex flex-col justify-center items-center gap-10 pb-10">
                
                <h2>${<NumberFlow value={statValue} />} handed out.</h2>
                <h2> 76 scholarships funded.</h2>
                <h2> All given back to the community.</h2>
            </div>
            <h1>About Us</h1>
            <p className="text-justify"> Welcome to the Waco Professional Firefighter Benefit Association, where bravery, service, and solidarity define who we are.
                <br /><br />
                As an esteemed association dedicated to the welfare and support of firefighters, we stand united in our commitment to honor, protect, and empower those who bravely serve our communities.
                <b> Our mission is to provide comprehensive benefits, resources, and unwavering support to ensure the well-being of our courageous members and their families. </b>
                Together, we uphold the values of dedication, integrity, and brotherhood, reflecting the true spirit of firefighting.
            </p>
            <img src={waco} alt="Waco Firefighters" className="rounded-[30px] border-[16px] border-white shadow-[0_5px_10px_rgba(0,0,0,0.1)] transition-transform duration-200 ease-in-out h-[350px] max-md:h-[200px] max-md:border-[8px]" />
            <h1>Our Mission</h1>
            <p className="text-justify">At the Waco Professional Firefighter Benefit Association, our mission is clear: <b> to honor and support the heroes who safeguard our community. </b>We provide vital resources, financial aid, and a network of care for firefighters and their families. Our commitment to service extends beyond the firehouse, fostering a community built on trust, respect, and mutual support.
                <br /><br />
                Our Scholarship Program has significantly impacted the lives of many children and teenagers, offering them the opportunity to advance their college education through essential financial support. By alleviating financial burdens, we enable these young individuals to focus on their studies and achieve their academic goals.
                <br /><br />
                However, to continue this vital work, we rely on the generosity of donors like you. <b> Your contribution can make a real difference, opening doors to education and brighter futures for deserving students. </b>  We kindly ask for your support in sustaining and expanding our scholarship offerings. Every donation, no matter the size, helps us reach more students in need. Thank you for considering a gift to our program and for being a part of our mission to educate and empower the next generation.
                <br /><br />
                <a className="text-blue-500 underline font-bold text-sm flex flex-row items-center text-center justify-center gap-1" href="/appreciation">Read stories of appreciation from those we've helped <ArrowRight className="h-4 w-4"/></a>
            </p>

            <div className="grid grid-cols-2 gap-[10px] md:grid-cols-5">
                {loading ? (
                    <p className="col-span-full text-center">Loading images...</p>
                ) : images.length === 0 ? (
                    <p className="col-span-full text-center"></p>
                ) : (
                    images.map((image, index) => {
                        const rotation = rotations[index % rotations.length];
                        const imageKey = `img_${index}`;

                        return (
                            <img
                                key={imageKey}
                                className="rounded-[30px] border-[8px] border-white shadow-[0_5px_10px_rgba(0,0,0,0.1)] transition-transform duration-100 ease-in-out h-[200px] w-[200px] aspect-[1/1] object-cover max-md:h-[250px]"
                                src={image.url}
                                alt={`Firefighter ${index + 1}`}
                                height={100}
                                style={{
                                    transform: hoveredImage === imageKey ? 'rotate(0deg) scale(1.5)' : `rotate(${rotation}deg) scale(1)`,
                                    zIndex: hoveredImage === imageKey ? 1 : 0
                                }}
                                onMouseEnter={() => handleMouseEnter(imageKey)}
                                onMouseLeave={handleMouseLeave}
                            />
                        );
                    })
                )}
            </div>
        </div>
    );
}

export default About;
